import { react2angular } from 'react2angular';
import app from '../../../browser/addform/scripts/app';
import { N1PublicationBannerWrapper } from './N1PublicationBanner.container';

app.component('n1PublicationBanner', react2angular(N1PublicationBannerWrapper, [], ['config', 'logger', 'httpApi']));
